import { Link } from 'react-router-dom'
import { PencilSquareIcon } from '@heroicons/react/20/solid'

import { useAuthStore } from 'features/auth/useAuthStore'
import { cn } from 'utils/cn'
import { Button } from 'shadcdn/ui/button'
import { SoftwareSchema } from 'openapi'
import { AdminSofwarePagePath } from 'features/admin/routes'

export const AdminButtonLink = (props: { software: SoftwareSchema; className?: string }) => {
  const { software, className } = props

  const user = useAuthStore((state) => state.user)

  if (!user?.isStaff) return null

  return (
    <>
      <hr className="border-gray-300" />

      <Link
        to={AdminSofwarePagePath({ softwareId: software.id })}
        rel="noreferrer"
        className={cn(`text-sm w-44 w-full`, className)}
      >
        <Button variant="secondary" className="w-full">
          <PencilSquareIcon className="h-5 w-5 mr-2" aria-hidden="true" />
          Edit
        </Button>
      </Link>
    </>
  )
}
